module.exports = __webpack_public_path__ + "static/media/del.b6f91f88.svg";